import { createStore } from 'vuex';
import { Store } from 'vuex';
declare module '#app' {
  interface NuxtApp {
    $store: Store<State>;
  }
}

interface State {
  tenant: any;
  geoBlockFlag: any;
  geoBlock: any;
  i18nn: any;
  gtmm: any;
  colorsConfig: any;
  configs: any;
  parentalConfig: {};
  loginOptions: [],
  device: any;
}

const VuexStore = {
  state() {
    return {
      tenant: null,
      geoBlockFlag: null,
      geoBlock: null,
      i18nn: null,
      gtmm: null,
      colorsConfig: null,
      configs: null,
      parentalConfig: {},
      loginOptions: [],
      device: null as null | { deviceId: number; operatingSystem: string },
    };
  },
  mutations: {
    setTenant(state, tenant) {
      state.tenant = tenant;
    },
    setI18nn(state, i18nn) {
      state.i18nn = i18nn;
    },
    setIGtm(state, gtmm) {
      state.gtmm = gtmm;
    },
    setColors(state, colorsConfig) {
      state.colorsConfig = colorsConfig;
    },
    setConfigs(state, configs) {
      state.configs = configs;
    },
    setParentalConfig(state, parentalConfig) {
      state.parentalConfig = parentalConfig;
    },
    setDevice(state, device) {
      state.device = device;
    },
    setGeoBlock(state, geoBlock) {
      state.geoBlock = geoBlock;
    },
    setLoginOptions(state, loginOptions) {
    state.loginOptions = loginOptions;
  },
    setGeoBlockFlag(state, geoBlockFlag) {
      state.geoBlockFlag = geoBlockFlag;
    },
  },
};

export default defineNuxtPlugin((nuxtApp) => {
  const store = createStore(VuexStore)
  nuxtApp.vueApp.use(store)

  if (process.server) {
    nuxtApp.payload.vuex = store.state
  } else if (nuxtApp.payload && nuxtApp.payload.vuex) {
    store.replaceState(nuxtApp.payload.vuex as any)
  }

  return {
    provide: {
      store,
    },
  };
});
